import { render, staticRenderFns } from "./AgoraCall.vue?vue&type=template&id=6febc358&scoped=true"
import script from "./AgoraCall.vue?vue&type=script&lang=js"
export * from "./AgoraCall.vue?vue&type=script&lang=js"
import style0 from "./AgoraCall.vue?vue&type=style&index=0&id=6febc358&prod&lang=scss&scoped=true"
import style1 from "./AgoraCall.vue?vue&type=style&index=1&id=6febc358&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6febc358",
  null
  
)

export default component.exports